import "./HomeLoan.scss";
import HomeLoanGuard from "./HomeLoanGuard";
import { R_HLRoutes } from "../../utils/Routes";
import { lazy } from "react";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const HomeloanDetails = lazy(() => import("./HomeloanDetails/HomeloanDetails"));
const InterestCertificate = lazy(
  () => import("./HomeloanInterestCertificate/InterestCertificate"),
);
const HomeLoanStatement = lazy(
  () => import("./HomeLoanStatement/HomeLoanStatement"),
);
const DisbursementRequest = lazy(
  () => import("./DisbursementRequest/DisbursementRequest"),
);
const EMI_payment = lazy(() => import("./EMI_payments/EMI_payment"));
const HomeloanChangeEnach = lazy(
  () => import("./HomeloanChangeEnach/RegisterChangeEnach"),
);
const ChangeAddress = lazy(() => import("./ChangeAddress/ChangeAddress"));
const HomeLoanExcessEMIRefund = lazy(
  () => import("./HomeLoanExcessEMIRefund/ExcessEMIRefund"),
);
const Homeloanuploaddocument = lazy(
  () => import("./Homeloanuploaddocument/Homeloanuploaddocument"),
);
const HomeloanServiceDetails = lazy(
  () => import("./HomeloanServiceDetails/HomeloanServiceDetails"),
);
const ChangeEmiTenure = lazy(() => import("./HL_EmiTenure/ChangeEmiTenure"));
const TenureChangeCharges = lazy(
  () => import("./HL_EmiTenure/TenureChangeCharges/TenureChangeCharges"),
);
const ChangeEmiMoreOptions = lazy(
  () => import("./HL_EmiTenure/TenureChangeOption3/ChangeEmiMoreOptions"),
);
const ChangeEmiDate = lazy(() => import("./ChangeEmiDate/ChangeEmiDate"));
const HomeLoanTdsRefund = lazy(() => import("./HomeLoanTdsRefund/TdsRefund"));
const HomeloanChangeEmail = lazy(
  () => import("./HomeloanChangeEmail/HomeloanChangeEmail"),
);
const HLBalanceConfirmationLetter = lazy(
  () => import("./HLBalanceConfirmationLetter/HLBalanceConfirmationLetter"),
);
const HomeLoanChangeMobile = lazy(
  () => import("./HomeLoanChangeMobile/HomeLoanChangeMobile"),
);
const ChangeEmiSelectDate = lazy(
  () => import("./ChangeEmiDate/ChangeEmiSelectDate"),
);
const ChangeEmiDateUploadDocument = lazy(
  () => import("./ChangeEmiDate/ChangeEmiDateUploadDocument"),
);

const Advance_EMI_payment = lazy(
  () => import("./HLAdvanceEMIPayment/Advance_EMI_Payment"),
);

const StatementAndDocument = lazy(
  () => import("./HLStatement&Documents/HLStatement&Document"),
);
const RoiHistory = lazy(() => import("./ROIHistory/ROIHistory"));
const PDDPage = lazy(() => import("./PostDisbursementDocument/PDDPage"));
const ReKycPage = lazy(() => import("./ReKyc/ReKycPage"));

const HomeloanRoutesFn = () => {
  return [
    {
      path: R_HLRoutes.home_loan_baseUrl,
      element: <HomeLoanGuard />,
      children: [
        {
          path: R_HLRoutes.home_loan_details,
          element: <SuspenseWrapper LazyLoadingComponent={HomeloanDetails} />,
        },
        {
          path: R_HLRoutes.interest_certificate,
          element: (
            <SuspenseWrapper LazyLoadingComponent={InterestCertificate} />
          ),
        },
        {
          path: R_HLRoutes.account_statement,
          element: <SuspenseWrapper LazyLoadingComponent={HomeLoanStatement} />,
        },
        {
          path: R_HLRoutes.disbursement_request,
          element: (
            <SuspenseWrapper LazyLoadingComponent={DisbursementRequest} />
          ),
        },
        {
          path: R_HLRoutes.emi_payment,
          element: <SuspenseWrapper LazyLoadingComponent={EMI_payment} />,
        },
        {
          path: R_HLRoutes.change_enach,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanChangeEnach} />
          ),
        },
        {
          path: R_HLRoutes.change_address,
          element: <SuspenseWrapper LazyLoadingComponent={ChangeAddress} />,
        },
        {
          path: R_HLRoutes.excess_emi_refund,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeLoanExcessEMIRefund} />
          ),
        },
        {
          path: R_HLRoutes.document_upload,
          element: (
            <SuspenseWrapper LazyLoadingComponent={Homeloanuploaddocument} />
          ),
        },
        {
          path: R_HLRoutes.home_loan_service_request,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanServiceDetails} />
          ),
        },
        {
          path: R_HLRoutes.home_loan_change_emi_tenure,
          element: <SuspenseWrapper LazyLoadingComponent={ChangeEmiTenure} />,
          children: [
            {
              path: R_HLRoutes.home_loan_change_emi_tenure_charges,
              element: (
                <SuspenseWrapper LazyLoadingComponent={TenureChangeCharges} />
              ),
            },
            {
              path: R_HLRoutes.home_loan_change_emi_tenure_option3,
              element: (
                <SuspenseWrapper LazyLoadingComponent={ChangeEmiMoreOptions} />
              ),
            },
          ],
        },
        {
          path: R_HLRoutes.home_loan_change_emi_date,
          element: <SuspenseWrapper LazyLoadingComponent={ChangeEmiDate} />,
        },
        {
          path: R_HLRoutes.home_loan_tds_request,
          element: <SuspenseWrapper LazyLoadingComponent={HomeLoanTdsRefund} />,
        },
        {
          path: R_HLRoutes.home_loan_change_email,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeloanChangeEmail} />
          ),
        },
        {
          path: R_HLRoutes.balance_confirmation_letter,
          element: (
            <SuspenseWrapper
              LazyLoadingComponent={HLBalanceConfirmationLetter}
            />
          ),
        },
        {
          path: R_HLRoutes.home_loan_change_mobile,
          element: (
            <SuspenseWrapper LazyLoadingComponent={HomeLoanChangeMobile} />
          ),
        },
        {
          path: R_HLRoutes.change_emi_select_date,
          element: (
            <SuspenseWrapper LazyLoadingComponent={ChangeEmiSelectDate} />
          ),
        },
        {
          path: R_HLRoutes.change_emi_upload_doc,
          element: (
            <SuspenseWrapper
              LazyLoadingComponent={ChangeEmiDateUploadDocument}
            />
          ),
        },
        {
          path: R_HLRoutes.advance_emi_payment,
          element: (
            <SuspenseWrapper LazyLoadingComponent={Advance_EMI_payment} />
          ),
        },
        {
          path: R_HLRoutes.post_disbursement_document,
          element: <SuspenseWrapper LazyLoadingComponent={PDDPage} />,
        },
        {
          path: R_HLRoutes.statement_and_document,
          element: (
            <SuspenseWrapper LazyLoadingComponent={StatementAndDocument} />
          ),
        },
        {
          path: R_HLRoutes.re_kyc,
          element: <SuspenseWrapper LazyLoadingComponent={ReKycPage} />,
        },
      ],
    },
    {
      path: R_HLRoutes.home_loan_roi_history,
      element: <SuspenseWrapper LazyLoadingComponent={RoiHistory} />,
    },
  ];
};
export { HomeloanRoutesFn };
